import React, { Component } from 'react';
import { Breadcrumb, Icon } from 'antd';
import { withRouter, Link } from 'react-router-dom';
import './AppBreadcrumb.less';

class AppBreadcrumb extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Breadcrumb>
                <Breadcrumb.Item key="home">
                    <Link to="/home">
                        <Icon type="home" />{'  '}<span>Waste Management</span>
                    </Link>
                </Breadcrumb.Item>
                {this.props.appRoutes.map((route, idx) => {
                    return this.props.location.pathname.includes(route.path) ?
                        (<Breadcrumb.Item key={idx}>
                        <span>{route.name}</span>
                    </Breadcrumb.Item>) : null
                })}
            </Breadcrumb>
        );
    }
}

export default withRouter(AppBreadcrumb);
